import * as style from './CompUtils.module.less';
import { convertMarkdown } from './Utils';

// const markup_test = `
// ## Balance Sheet

// | Historical & Projected Balance Sheet |   |   |   |   |   |   |   |   |   |   |   |
// |---|---|---|---|---|---|---|---|---|---|---|---|
// | ($ in Millions) | 2020(A) | 2021(A) | 2022(A) | 2023(A) | 2024(A) | 2025(P) | 2026(P) | 2027(P) | 2028(P) | 2029(P) | 2030(P) |
// | Cash & Equivalents | 1 | 1.20 | 2 | 3.50 | 6 | 9 | 13 | 18 | 25 | 33 | 42 |
// | Accounts Receivable | 0.50 | 0.72 | 1.08 | 1.62 | 2.43 | 3.60 | 5.10 | 7 | 9.50 | 12.4 | 15.5 |
// | Other Current Assets | 0.50 | 0.60 | 0.80 | 1 | 1.20 | 1.50 | 1.80 | 2.10 | 2.50 | 2.90 | 3.30 |
// | Total Current Assets | 2 | 2.52 | 3.88 | 6.12 | 9.63 | 14.1 | 19.9 | 27.1 | 37 | 48.3 | 60.8 |
// | PP&E (net) | 0.80 | 1.10 | 1.30 | 1.60 | 2 | 2.40 | 2.90 | 3.30 | 3.70 | 4.10 | 4.50 |
// | Intangibles (capitalised SW) | 2 | 2.20 | 2.50 | 3 | 3.50 | 4 | 4.50 | 5 | 5.60 | 6.20 | 6.90 |
// | Other Non‑Current Assets | 0.40 | 0.50 | 0.60 | 0.70 | 0.80 | 0.90 | 1 | 1.10 | 1.20 | 1.30 | 1.40 |
// | Total Non‑Current Assets | 3.20 | 3.80 | 4.40 | 5.30 | 6.30 | 7.30 | 8.40 | 9.40 | 10.5 | 11.6 | 12.8 |
// | Total Assets | 5.20 | 6.32 | 8.28 | 11.4 | 15.9 | 21.4 | 28.3 | 36.5 | 47.5 | 59.9 | 73.6 |
// | Accounts Payable | 0.30 | 0.40 | 0.60 | 0.90 | 1.30 | 1.80 | 2.20 | 2.80 | 3.50 | 4.20 | 5 |
// | Accrued Expenses | 0.20 | 0.30 | 0.40 | 0.50 | 0.70 | 0.90 | 1.20 | 1.50 | 1.90 | 2.20 | 2.60 |
// | Deferred Revenue | 1 | 1.44 | 2.16 | 3.24 | 4.86 | 7.20 | 10.2 | 14 | 19 | 24.8 | 31 |
// | Current Liabilities (subtotal) | 1.50 | 2.14 | 3.16 | 4.64 | 6.86 | 9.90 | 13.6 | 18.3 | 24.4 | 31.2 | 38.6 |
// | Long‑Term Debt | 1 | 1 | 1 | 1 | 1 | 5 | 5 | 5 | 5 | 5 | 5 |
// | Total Liabilities | 2.50 | 3.14 | 4.16 | 5.64 | 7.86 | 14.9 | 18.6 | 23.3 | 29.4 | 36.2 | 43.6 |
// | Shareholders’ Equity | 2.70 | 3.18 | 4.12 | 5.78 | 8.07 | 6.50 | 9.70 | 13.2 | 18.1 | 23.7 | 30 |
// | Total Liabilities & Equity | 5.20 | 6.32 | 8.28 | 11.4 | 15.9 | 21.4 | 28.3 | 36.5 | 47.5 | 59.9 | 73.6 |
// `;
export const formatDivMarkup = (markup: string, classes: string = '') => {
    const dangerousHtml = convertMarkdown(markup);
    return (
        <div
            className={classes + ' ' + style.prose_table}
            dangerouslySetInnerHTML={{
                __html: dangerousHtml
            }}
        ></div>
    );
};

export const formatModuleVariableName = (raw: string): string => {
    if (!raw.startsWith('v_')) {
        return raw;
    }
    return raw
        .slice(2)
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
